import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { debounceTime, Subject } from 'rxjs';

import { OrderService, SortBy, SortDir, UpdateOrdersStatus } from 'app/services/order/order.service';
import { CombinedOrderWithOrdersDto } from 'app/models/order';
import { ProductDataDto } from 'app/models/product-data-dto';
import { ProductService, SimpleProduct } from 'app/services/product/product.service';
import { ImageFallbackDirective } from "app/modules/admin/directives/ImageFallbackDirective";
import { ImageUrlPipe } from 'app/modules/admin/pipe/image-url.pipe';
import { VariableBinding } from '@angular/compiler';

type BulkAction = '' | 'mark_paid' | 'mark_unpaid' | 'mark_delivered' | 'mark_pending' | 'export_ids';

@Component({
  selector: 'app-orders',
  standalone: true,
  imports: [CommonModule, FormsModule, ImageFallbackDirective,ImageUrlPipe],
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.scss']
})
export class OrdersComponent implements OnInit {
  
  payment_Statuses = [
    { key: 'PAID', value: 'Paid' },
    { key: 'UNPAID', value: 'UnPaid' },
    { key: 'REFUNDED', value: 'Refunded' },
  ];
  order_Statuses = [
    { key: 'PENDING', value: 'Pending' },
    // { key: 'HOLDING', value: 'Holding' },
    { key: 'CONFIRMED', value: 'Confirmed' },
    // { key: 'PACKED', value: 'Packed' },
    // { key: 'SHIPPED', value: 'Shipped' },
    // { key: 'IN_TRANSIT', value: 'InTransit' },
    { key: 'OUT_FOR_DELIVERY', value: 'OutForDelivery' },
    // { key: 'DELIVERED', value: 'Delivered' },
    { key: 'COMPLETED', value: 'Completed' },
    // { key: 'RETURN_REQUESTED', value: 'ReturnRequested' },
    // { key: 'RETURNED', value: 'Returned' },
    { key: 'CANCELLED', value: 'Cancelled' },
    // { key: 'FAILED', value: 'Failed' }
  ];
  
  Statuses = [...this.payment_Statuses,...this.order_Statuses];

  isLoading = false;

  // Pagination
  page = 1;
  pageSize = 10;
  totalCount = 0;
  totalPages = 1;

  // Sorting
  sortBy: SortBy = 'id';
  sortDir: SortDir = 'desc';

  // Search by OrderId
  orderIdSearch: number | null = null;
  search: string | null = null;
  private search$ = new Subject<string>();

  // Data
  combinedOrders: any[] = []; // any عشان نضيف fields UI زي shipping_address_obj
  products:SimpleProduct[];
  prdsIds = new Set<number>();

  // Modal
  showOrdersModal = false;
  selectedCombined: any = null;

  // =========================
  // Selection + Bulk actions
  // =========================
  selectedIds = new Set<number>();
  bulkAction:string = '';

  constructor(private orderService: OrderService,private productService:ProductService) {
    this.search$.pipe(debounceTime(400)).subscribe((val) => {
      const n = val ? Number(val) : NaN;
      this.orderIdSearch = Number.isFinite(n) && n > 0 ? n : null;
      this.search = val
      this.page = 1;
      this.load();
    });
  }

  ngOnInit(): void {
    this.load();
  }
// في الـ component.ts
getStatusClass(status: string): string {
  if (!status) return 'pending';
  return status.toLowerCase().replace(/[^a-z]/g, '');
}
  reload() {
    this.page = 1;
    this.search = ''
    this.load();
  }

  onSearchOrderId(event: any) {
    const v = (event?.target?.value ?? '').toString().trim();
    console.log(v);
    this.search$.next(v);
  }

  load() {
    if (this.isLoading) return;
    this.isLoading = true;

    // ✅ مهم: مع أي load جديد (pagination/sort/search) هنصفر الاختيارات للصفحة الحالية
    this.selectedIds.clear();
    this.bulkAction = '';
    console.log(this.orderIdSearch);
    console.log(this.search);
    console.log(this.sortBy);
    this.orderService
      .getAllOrdersWithDetails(this.page, this.pageSize, this.orderIdSearch, this.sortBy, this.sortDir , this.search )
      .subscribe({
        next: (res: any) => {
          console.log(res);
          if (!res?.success) {
            this.reset();
            this.isLoading = false;
            return;
          }
          this.page = Number(res?.page ?? this.page);
          this.pageSize = Number(res?.page_size ?? res?.pageSize ?? this.pageSize);
          this.totalCount = Number(res?.total_count ?? res?.totalCount ?? 0);
          this.totalPages = Number(res?.total_pages ?? res?.totalPages ?? 1);

          const list = (res?.data ?? []) as CombinedOrderWithOrdersDto[];

          this.combinedOrders = list.map((co: any) => ({
            ...co,
            shipping_address_obj: this.tryParseJson(co.shipping_address),
            orders: (co.orders ?? []).map((o: any) => ({
              ...o,
              details: o.details ?? []
            }))
          }));

          this.isLoading = false;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        error: (err: any) => {
          console.error(err);
          this.reset();
          this.isLoading = false;
        }
      });
  }

  private reset() {
    this.combinedOrders = [];
    this.totalCount = 0;
    this.totalPages = 1;

    this.selectedIds.clear();
    this.bulkAction = '';

    this.closeOrdersModal();
  }

  // =========================
  // Modal
  // =========================

updateOrderStatus(order: any, field: 'payment_status' | 'delivery_status') {
  const payload : UpdateOrdersStatus = {
    orders_ids: [order.id],
    status: order[field]
  };

  // Loading بسيط للصف
  order._updating = true;

  this.orderService.UpdateOrdersStatus(payload).subscribe({
    next: () => {
      order._updating = false;     
      this.load();
    },
    error: () => {
      order._updating = false;
      // رجّع القيمة القديمة لو حابب
      // أو اعرض toast error
    }
  });
}
saveOldStatus(order:any, field:string){
  order[`old_${field}`] = order[field];
}
deleteOrder(co:any){
  
  this.orderService.DeleteOrder(co?.id).subscribe({
    next: () => {
      this.load();
    },
    error: () => {
      // رجّع القيمة القديمة لو حابب
      // أو اعرض toast error
    }
  });
}



  openOrdersModal(co: any) {
    const cloned = JSON.parse(JSON.stringify(co));
    cloned.shipping_address_obj =
      cloned.shipping_address_obj ?? this.tryParseJson(cloned.shipping_address);

    this.selectedCombined = cloned;
    
    // Clear previous product ids to prevent accumulation
    this.prdsIds.clear();
    
    // Collect product ids from all orders
    cloned.orders.forEach((o: any) => {
      (o.details ?? []).forEach((element: any) => {
        if (element.product_id) {
          this.prdsIds.add(element.product_id);
        }
      });
    });

    if (this.prdsIds.size === 0) {
      this.showOrdersModal = true;
      return;
    }

    this.productService.getProductsByIds(Array.from(this.prdsIds)).subscribe({
      next: (res) => {
        cloned.orders.forEach((o: any) => {
          (o.details ?? []).forEach((ele: any) => {
            const product = res.find(p => p.id === ele.product_id);
            if (product) {
              ele.product = product; // Add product details inside detail
            }
          });
        });
        console.log(cloned);
        this.showOrdersModal = true;
      },
      error: (err) => {
        console.error(err);
        this.showOrdersModal = true; // Show modal even if fetching product details fails
      }
    });
  }

  closeOrdersModal() {
    this.showOrdersModal = false;
    this.selectedCombined = null;
  }

  private tryParseJson(val: any): any {
    if (!val) return null;
    if (typeof val === 'object') return val;

    if (typeof val === 'string') {
      try {
        return JSON.parse(val);
      } catch {
        return null;
      }
    }
    return null;
  }

  // =========================
  // Pagination
  // =========================
  goToPage(p: number) {
    if (p < 1 || p > this.totalPages || p === this.page) return;
    this.page = p;
    this.load();
  }

  previousPage() {
    if (this.page <= 1) return;
    this.page--;
    this.load();
  }

  nextPage() {
    if (this.page >= this.totalPages) return;
    this.page++;
    this.load();
  }

  getPageNumbers(): number[] {
    const pages: number[] = [];
    const maxVisible = 5;
    const safeTotal = this.totalPages || 1;

    let start = Math.max(1, this.page - Math.floor(maxVisible / 2));
    let end = Math.min(safeTotal, start + maxVisible - 1);

    if (end - start + 1 < maxVisible) {
      start = Math.max(1, end - maxVisible + 1);
    }

    for (let i = start; i <= end; i++) pages.push(i);
    return pages;
  }

  getStartIndex(): number {
    if (this.totalCount === 0) return 0;
    return (this.page - 1) * this.pageSize + 1;
  }

  getEndIndex(): number {
    const end = this.page * this.pageSize;
    return Math.min(end, this.totalCount);
  }

  // =========================
  // Selection helpers
  // =========================
  toggleRowSelection(order: any, checked: boolean): void {
  const id = Number(order?.id);
  const orderId = Number(order?.orders[0]?.id);

  if (!Number.isFinite(id)) {
    return;
  }

  if (checked) {
    this.selectedIds.add(orderId);
  } else {
    this.selectedIds.delete(orderId);
  }
}

  isSelected(co: any): boolean {
    const id = Number(co?.orders[0]?.id);
    return Number.isFinite(id) ? this.selectedIds.has(id) : false;
  }

  isAllCheckedOnPage(): boolean {
    if (!this.combinedOrders?.length) return false;
    return this.combinedOrders.every(co => this.selectedIds.has(Number(co.id)));
  }

  isSomeCheckedOnPage(): boolean {
    if (!this.combinedOrders?.length) return false;
    const any = this.combinedOrders.some(co => this.selectedIds.has(Number(co?.orders[0]?.id)));
    return any && !this.isAllCheckedOnPage();
  }

  toggleCheckAllOnPage() {
    if (!this.combinedOrders?.length) return;

    const allChecked = this.isAllCheckedOnPage();
    if (allChecked) {
      // uncheck all on this page
      this.combinedOrders.forEach(co => this.selectedIds.delete(Number(co?.orders[0]?.id)));
    } else {
      // check all on this page
      this.combinedOrders.forEach(co => this.selectedIds.add(Number(co?.orders[0]?.id)));
    }
  }

  clearSelection() {
    this.selectedIds.clear();
    this.bulkAction = '';
  }

  getSelectedCount(): number {
    return this.selectedIds.size;
  }

  // =========================
  // Bulk actions (Placeholder)
  // =========================
  applyBulkAction() {
    console.log("here");
    const ids = Array.from(this.selectedIds);

    if (!ids.length) {
      alert('اختر طلب واحد على الأقل.');
      return;
    }


    if (!this.bulkAction) {
      alert('اختر Bulk Action.');
      return;
    }

    var request :UpdateOrdersStatus ={
      orders_ids : ids,
      status : this.bulkAction
    }
    console.log(request);
    // ✅ هنا انت تحدد هتعمل إيه في الباك اند
     مثال: this.orderService.UpdateOrdersStatus(request).subscribe({
      next:(res:any)=>{
        console.log(res);
        if (res.success) {
          this.load();
        }
      }
     })

    

    // بعد التنفيذ عادة نعمل reload
    this.load();
  }
}
